import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {AncientTreasureExchangeConfig} from "@/modules/redactor/models/smart-offer/bundle-ancient-treasure/AncientTreasureExchangeConfig";

export class SmartOfferBundleAncientTreasure extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.ANCIENT_TREASURE);

        this._currency_chest = null;
        this._currency_progress = null;

        this._freeKeys = 0;

        this._exchangeConfig = null;

        this._rewards = null;
        this._rewards_premium = null;

        this._chests = null;
        this._chests_optional = null;

        this._statue_item = null;
        this._product = null;
    }

    get freeKeys() {
        return this._freeKeys;
    }

    set freeKeys(value) {
        this._freeKeys = value;
    }

    get currency_chest() {
        return this._currency_chest;
    }

    set currency_chest(value) {
        this._currency_chest = value;
    }

    get currency_progress() {
        return this._currency_progress;
    }

    set currency_progress(value) {
        this._currency_progress = value;
    }

    get exchangeConfig() {
        return this._exchangeConfig;
    }

    set exchangeConfig(value) {
        this._exchangeConfig = value;
    }

    get rewards() {
        return this._rewards;
    }

    set rewards(value) {
        this._rewards = value;
    }

    get rewards_premium() {
        return this._rewards_premium;
    }

    set rewards_premium(value) {
        this._rewards_premium = value;
    }

    get chests() {
        return this._chests;
    }

    set chests(value) {
        this._chests = value;
    }

    get chests_optional() {
        return this._chests_optional;
    }

    set chests_optional(value) {
        this._chests_optional = value;
    }

    get statue_item() {
        return this._statue_item;
    }

    set statue_item(value) {
        this._statue_item = value;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if(!Number.isInteger(this.freeKeys) || this._freeKeys < 0){
            return false;
        }

        if (!CurrencyKindModel.is(this.currency_chest)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.currency_progress)) {
            return false;
        }

        if (!this.exchangeConfig || !this.exchangeConfig.valid()) {
            return false;
        }

        // validate chests tracks
        if (!this.rewards || this.rewards.empty()) {
            return false;
        }

        if (this.rewards && !this.rewards.valid()) {
            return false;
        }

        if (this.rewards_premium && !this.rewards_premium.valid()) {
            return false;
        }

        // validate chests tracks
        if (!this.chests || this.chests.empty()) {
            return false;
        }

        if (this.chests && !this.chests.valid()) {
            return false;
        }

        if (this.chests_optional && !this.chests_optional.valid()) {
            return false;
        }

        if (this.statue_item && (!this.statue_item.valid() || this.statue_item.any())) {
            return false;
        }

        return true;
    }

    empty() {

        if (!this.rewards || this.rewards.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleAncientTreasure());
        } else if (target instanceof SmartOfferBundleAncientTreasure) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleAncientTreasure, {

    _freeKeys: alias("free_keys", Schema.primitive()),

    _currency_chest: alias("currency_chest", CurrencyKindModel.schema()),
    _currency_progress: alias("currency_progress", CurrencyKindModel.schema()),

    _rewards: alias("rewards", RewardBunch.schema()),
    _rewards_premium: alias("rewards_premium", RewardBunch.schema()),

    _chests: alias("chests", RewardBunch.schema()),
    _chests_optional: alias("chests_optional", RewardBunch.schema()),

    _statue_item: alias("statue_item", ItemKey.schema()),

    _product: alias("product", Schema.primitive()),

    _exchangeConfig: alias("exchange_config", AncientTreasureExchangeConfig.schema())
});

